import Api from "../api";
import qs from "qs";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ResponseDataType } from "@/form/form.types";
import { IServicesRepository } from "@/repository/services/ServicesRepository.types";
import {
    IServices,
    IServicesListItem,
    ServicesResponseType,
} from "@/entity/services/services.types";
import Services from "@/entity/services/services";
import {
    ServiceCreateRequestType
} from "@/form/serviceCreate/serviceCreate.types";
import { ServiceAvailableRequestType } from "@/form/serviceAvailableCopy/serviceAvailable.type";

export class ServicesRepository implements IServicesRepository {
    async fetchAll(data?: FormData): Promise<IServices> {
        const response = await Api.get("/service/get", {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString();
            },
        });
        const responseData = response.data as ServicesResponseType;
        return new Services(responseData);
    }

    async fetchData(data: PaginationRequestType): Promise<IServicesListItem> {
        const response = await Api.get(`/service/get`, {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
            },
        });
        const responseData = response.data as ServicesResponseType;
        return new Services(responseData).data[0];
    }

    async copy(data: ServiceAvailableRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service/copy`, data);
        return response.data;
    }

    async create(data: ServiceCreateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service/create`, data);
        return response.data;
    }
    async update(data: ServiceCreateRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service/update`, data);
        return response.data;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/service/delete`, data);
        return response.data;
    }
}
